module.exports = __webpack_public_path__ + "static/media/Knauf_Insulation_Logo.9d350a5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Knauf_Insulation_Logo.png
// module id = 368
// module chunks = 0